export const EnrollmentStatus = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    PENDING: 'PENDING',
};

export const EnrollmentSource = {
    LOCAL: 'Enrollment File',
    MIRTH: 'API',
};

export const mapEnrollment = (enrollment) => ({
    enrollmentId: enrollment.enrollment_id,
    fmhMemberId: enrollment.fmh_member_id,
    cardholderId: enrollment.cardholder_id,
    carrier: enrollment.carrier,
    account: enrollment.account,
    benefitGroup: enrollment.benefit_group,
    benefitCode: enrollment.benefit_code,
    enrollmentStart: enrollment.enrollment_start,
    enrollmentEnd: enrollment.enrollment_end,
    insuranceType: enrollment.insurance_type,
    relationshipCode: enrollment.relationship_code,
    secondaryCoverageFlag: enrollment.secondary_coverage_flag,
    memberPin: enrollment.member_pin,
    enrollmentSource: enrollment.enrollment_source,
    enrollmentCheckDate: enrollment.enrollment_check_date,
    isFmhEnrollmentEnd: enrollment.is_fmh_enrollment_end,
});
